


























import Vue from 'vue';

export default Vue.extend({
  props: {
    wide: Boolean,
    mini: Boolean,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    xLarge: Boolean,
    primary: Boolean,
    secondary: Boolean,
    campaign: Boolean,
    disabled: Boolean,
    border: Boolean,
    noBorder: Boolean,
  },
});
